import React, { Component } from 'react'

class EventInfoBox extends Component {
  render () {
    return (
      <div className='event-info-box'>
        <div className='event-info-box-content'>
          <div className='icon-container'>
            <i className={'fa fa-fw fa-' + this.props.icon} />
          </div>
          <div className='text-container'>
            <p className='event-info-name'>{this.props.name}</p>
            <p className='event-info-value'>{this.props.value}</p>
          </div>
        </div>
      </div>
    )
  }
}
export default EventInfoBox



// WEBPACK FOOTER //
// ./src/components/basic/containers/EventInfoBox.js